
import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

import imagenBienvenida1 from "../:./../../assets/img/bienvenida/bienvenida_1.png";
import imagenBienvenida2 from "../:./../../assets/img/bienvenida/bienvenida_2.png";
import imagenBienvenida3 from "../:./../../assets/img/bienvenida/bienvenida_3.png";
import './styles/CarruselBienvenida.scss';
const CarruselBienvenidaCurso = () => {
  const settings = {
    dots: true, // Muestra indicadores de posición
    infinite: true, // Bucle infinito
    speed: 500, // Velocidad de transición
    slidesToShow: 1, // Muestra 1 elemento a la vez
    slidesToScroll: 1, // Desplaza 1 elemento a la vez
  };

  return (
    <div className="b-content-detalle">
      <Slider {...settings}>
        <div className="col-12 md:col-4 mb-2 b-detalle-block flex">
          <div className="detalle-block-img">
            <img src={imagenBienvenida1}></img>
          </div>
          <div className="detalle-block-detalle text-sm font-medium mt-2">
            En este curso encontrarás diversas unidades con lecciones dentro de cada una. 
            Además, tendrás a tu disposición los videos, materiales complementarios y ejercicios 
            que nuestros docentes han elaborado para ti.
          </div>
        </div>

        <div className="col-12 md:col-4 mb-2 b-detalle-block flex">
          <div className="detalle-block-img">
            <img src={imagenBienvenida2}></img>
          </div>
          <div className="detalle-block-detalle text-sm font-medium mt-2">
            Al final de cada unidad te pediremos que respondas una evaluación, tendrás 2 intentos y 
            45 minutos en cada uno para poder contestar.
          </div>
        </div>

        <div className="col-12 md:col-4 mb-2 b-detalle-block flex">
          <div className="detalle-block-img">
            <img src={imagenBienvenida3}></img>
          </div>
          <div className="detalle-block-detalle text-sm font-medium mt-2">
            Para complementar tu aprendizaje tendrás habilitado un chat, donde podrás aclarar dudas 
            acerca del curso. Además, tendrás acceso a nuestra Biblioteca Virtual.
          </div>
        </div>
      </Slider>
    </div>
  );
};

export default CarruselBienvenidaCurso;
